import React, {Component} from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin'

import Navigation from '../../components/home/Navigation';
import CheckBox from '../../components/home/CheckBox';
import SearchResult from '../../components/home/SearchResult';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import * as searchInfoActions from '../../actions/searchInfoActions';
import * as loadInfoActions from '../../actions/loadInfoActions';

import PopUp from '../../components/home/PopUp';
import {ADVANCE_SEARCH_CONDITION, COMMON_SEARCH_CONDITION} from "../../config/localStoreKey";
import SessionStore from "../../util/sessionStore";
import {post} from "../../axios/post";
import Loading from "../../components/loading/Loading";

import {getRequest, obj2params} from '../../util/utils';


class NewHome extends Component {

    constructor(...props) {
        // noinspection JSCheckFunctionSignatures
        super(...props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.tab = this.tab.bind(this);
        this.getCondition = this.getCondition.bind(this);
        this.bookSearch = this.bookSearch.bind(this);
        this.addPageSearch = this.addPageSearch.bind(this);
        this.cutPageSearch = this.cutPageSearch.bind(this);
        this.loadingStyle = this.loadingStyle.bind(this);
        this.clearAll = this.clearAll.bind(this);
        this.commClean = this.commClean.bind(this);

        this.storeCommonConditionHistory = this.storeCommonConditionHistory.bind(this);
    }

    render() {
        // console.log("quanju ");

        return (
            <div>
                {/*<SuspendButton variant="outlined" color="primary" href="#outlined-buttons"
                        onClick={() => { window.location.href = '/?' }}> 返回</SuspendButton>*/}


                {/* 查询功能 页面 选择 */}
                <Navigation {...this.props}/>
                {/*搜索层*/}
                <CheckBox
                    {...this.props}
                    getCondition={this.getCondition}
                    bookSearch={this.bookSearch}
                    clear={this.clearAll}
                    commClean={this.commClean}
                />
                {/*信息展示层*/}
                <SearchResult
                    {...this.props}
                    addPageSearch={this.addPageSearch}
                    cutPageSearch={this.cutPageSearch}
                />
                {/*pop up 页面*/}
                <PopUp
                    searchInfo={this.props.searchInfo}
                    actions={this.props.searchInfoActions}
                    history={this.props.history}/>
                <Loading {...this.props}/>
            </div>
        )
    }

    componentDidMount() {
        let searchInfo = this.props.searchInfo;
        this.props.searchInfoActions.bookSearch({
            ...searchInfo,
            bookAddressStyle: {display: 'none'}
        });
        //    菜单切换；
        this.tab('.nav a', '.checkBox');
    }

    /**
     * tab切换
     * @param clickEl
     * @param elMain
     */
    tab(clickEl, elMain) {
        let clickEls = document.querySelectorAll(clickEl);
        let elMains = document.querySelectorAll(elMain);
        for (let i = 0; i < clickEls.length; i++) {
            clickEls[i].index = i;
            clickEls[i].onclick = function () {
                for (let i = 0; i < clickEls.length; i++) {
                    // clickEls[i].classList.remove('active');
                    // elMains[i].style.display = 'none';
                }
                // this.classList.add('active');
                // elMains[this.index].style.display = 'block';
            }
        }
    }

    /**
     * 获取查询条件 即查询请求的参数
     * @param conditionStr
     * @returns {*}
     */
    getCondition(conditionStr) {
        let searchInfo = this.props.searchInfo;
        if (conditionStr === COMMON_SEARCH_CONDITION) {
            let condition = searchInfo.condition;
            // if (!searchInfo.condition) {
            //     condition = SessionStore.getSessionItem(COMMON_SEARCH_CONDITION);
            //     condition = condition === "[object Object]" ? "" : condition;
            //     condition = condition === null ? "" : condition;
            // }
            return condition;
        } else if (conditionStr === ADVANCE_SEARCH_CONDITION) {
            let advanceCondition = searchInfo.advanceCondition;
            if (!advanceCondition) {
                // advanceCondition = SessionStore.getSessionItem(ADVANCE_SEARCH_CONDITION);
                // if (!advanceCondition) {
                advanceCondition = {
                    title: "",
                    author: "",
                    keyword: "",
                    publisher: "",
                    publish_year_start: "",
                    publish_year_end: "",
                    callno: "",
                    book_barcode: "",
                    //     }
                    // } else {
                    //     advanceCondition = JSON.parse(advanceCondition);
                }
            }
            return advanceCondition;
        }
        return undefined;
    }

    /**
     * 书籍查询
     */
    bookSearch() {
        this.advancedSearchAction(1);
    }

    /**
     * 下一页查询
     */
    addPageSearch() {
        let searchInfo = this.props.searchInfo;
        let bookList = searchInfo.bookList;
        let currentPage = bookList.currentPage;
        let pageCount = bookList.pageCount;
        if (currentPage >= pageCount) {
            alert("没有更多数据了！");
            return;
        }
        this.advancedSearchAction(currentPage + 1);
    }

    /**
     * 上一页查询
     */
    cutPageSearch() {
        let searchInfo = this.props.searchInfo;
        let bookList = searchInfo.bookList;
        let currentPage = bookList.currentPage;
        if (currentPage <= 1) {
            alert("没有更多数据了！");
            return;
        }
        this.advancedSearchAction(currentPage - 1);
    }


    /**
     * 高级查询
     * @param pageNo 查询页号
     */
    advancedSearchAction(pageNo) {
        const searchInfoActions = this.props.searchInfoActions;
        let searchInfo = this.props.searchInfo;
        let condition = this.getCondition(searchInfo.searchCondition);
        let conditionHistory = searchInfo.conditionHistory;

        // 普通查询 此时condition不是对象 是个字符串
        if (searchInfo.searchCondition === COMMON_SEARCH_CONDITION && condition !== undefined) {
            condition = {title: condition};
            // 历史信息存入
            conditionHistory = this.storeCommonConditionHistory();
        }
        // 展示加载loading
        this.loadingStyle('inline');
        let result = post('/analysisapp/QueryBookBasicInfo?', {
            ...getRequest(),
            ...condition,
            page_size: 20,
            page_no: pageNo
        });
        // 设置初始化数据
        let bookList = {data: [], pageCount: 0, currentPage: 0};
        result.then(bookInfo => {
            bookList = bookInfo;
        }).catch((err) => {
            // console.log('----------- >>>>> ' + err.toString());
            alert("很抱歉，查询失败！")
        }).finally(() => {
            this.loadingStyle('none');
            // console.log(this.getCondition(searchInfo.searchCondition));
            searchInfoActions.advancedSearch(
                {
                    ...searchInfo,
                    conditionHistory: conditionHistory,
                    bookList: bookList,
                    condition: searchInfo.condition,
                    // advanceCondition: JSON.parse(SessionStore.getSessionItem(ADVANCE_SEARCH_CONDITION))
                }
            );
        });
    }

    clearAll() {
        const searchInfoActions = this.props.searchInfoActions;
        let searchInfo = this.props.searchInfo;
        SessionStore.removeSeesionItem(ADVANCE_SEARCH_CONDITION);
        searchInfoActions.advancedSearch(
            {
                ...searchInfo,
                advanceCondition: undefined,
                bookList: {data: [], pageCount: 0, currentPage: 0}
            }
        );
    }

    commClean() {
        const searchInfoActions = this.props.searchInfoActions;
        let searchInfo = this.props.searchInfo;
        SessionStore.removeSeesionItem(COMMON_SEARCH_CONDITION);
        searchInfoActions.advancedSearch(
            {
                ...searchInfo,
                condition: undefined,
                bookList: {data: [], pageCount: 0, currentPage: 0}
            }
        );
    }


    /**
     * 存入当前查询的历史条件， 并控制历史条数只能是10条内
     * @returns {*|string[]}
     */
    storeCommonConditionHistory() {
        let searchInfo = this.props.searchInfo;
        let conditionHistory = searchInfo.conditionHistory;
        let condition = this.getCondition(searchInfo.searchCondition);
        conditionHistory = conditionHistory.filter(value => {
            return value !== condition;
        });

        conditionHistory = [condition, ...conditionHistory];

        // 这里的历史记录调数为10条 多余的将去除
        if (conditionHistory.length > 10) {
            conditionHistory = conditionHistory.filter((value, index) => {
                return index < 11;
            })
        }

        return conditionHistory;


    }


    /**
     * 请求后端 loading 页面
     * @param display
     */
    loadingStyle(display) {
        let loadInfoActions = this.props.loadInfoActions;
        let loadInfo = this.props.loadInfo;
        loadInfoActions.changeStyle({
            ...loadInfo,
            display: display,
        });
    }
}


// 数据信息 redux 模板
function mapStateToProps(state) {
    return {
        searchInfo: state.searchInfo,
        loadInfo: state.loadInfo
    }
}

function mapDispatchToProps(dispatch) {
    return {
        searchInfoActions: bindActionCreators(searchInfoActions, dispatch),
        loadInfoActions: bindActionCreators(loadInfoActions, dispatch),
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewHome)



// WEBPACK FOOTER //
// ./src/containers/home/NewHome.js